import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { MSAL_CONFIG, MSAL_CONFIG_ANGULAR } from '@azure/msal-angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  console.warn(`Console output is disabled on production!`);
  console.log = function (): void { return;};
  console.debug = function (): void { return;};
  console.warn = function (): void { return;};
  console.info = function (): void { return;};
}

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
fetch('/assets/configuration.json')
  .then(response => response.json())
  .then(json => {
    console.log('Res-json', json);
    environment['authority'] = json.authority ;
    environment['clientId'] = json.clientId;
    environment['tenantId'] = json.tenantId;
    environment['apiUrl'] = json.apiUrl;
    environment['apiUrl_RBAC'] = json.rbackUrl;
    environment['apiUrl_GIS'] = json.gisUrl;
    environment['apiUrl_CommonGIS'] = json.commGisUrl;
    environment['Ocp_Apim_Subscription_Key'] = json.ocpApimSubKey;
    environment['mapServerConfig']['baseUrl'] = json.mapServerUrl;
    environment['MYIM_CACHE_URL'] = json.cacheUrl;  
    environment['appInsights'] = json.instrumentationKey;

    const msalConfig = {
      auth: {
        clientId: environment['clientId'],
        postLogoutRedirectUri: '',
        authority: environment['authority'] + environment['tenantId'],
        redirectUri: window.location.origin,
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
      }
    };

    const protectedResourceMap: [string, string[]][] = [
      ['https://graph.microsoft.com/v1.0/me', ['user.read']],
      ['/entSharedServices', ['api://39506c23-76c5-4c3c-9fb4-c4c384114f98/Read']]
    ];
    
    const angularConfig = {
      consentScopes: ['user.read', 'openid', 'profile'],
      unprotectedResources: [],
      protectedResourceMap: protectedResourceMap,
      extraQueryParameters: {}
    };

    platformBrowserDynamic([
      { provide: MSAL_CONFIG, useValue: msalConfig },
      { provide: MSAL_CONFIG_ANGULAR, useValue: angularConfig }
    ]).bootstrapModule(AppModule);
  });
